module.exports = __webpack_public_path__ + "static/media/alert.55dfd9b7.svg";